import React from 'react';
import { withStyles } from '@material-ui/core';
import { StyledSelect } from '../../../../Dispatch/RouteExecution/Pickups/PickupManagement/components/Select';
import styles from './promptConfirmationSelectStyles';

type PromptConfirmationOption = {
  value: number;
  label: string;
};

type PromptConfirmationSelectWithLabelProps = {
  classes: Record<string, string>;
  id: string;
  value: number | string | null;
  error?: string | null;
  label?: string;
  suffix?: string;
  placeHolder?: string;
  data: PromptConfirmationOption[];
  onChange: (selectedOption: PromptConfirmationOption | null) => void;
};

const PromptConfirmationSelectWithLabel = ({
  id,
  classes,
  value,
  error,
  label = '',
  suffix = '',
  placeHolder = '',
  ...otherProps
}: PromptConfirmationSelectWithLabelProps) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <div className={classes.rowLabel}>{label}</div>
        <div className={classes.selectColumn}>
          <div className={classes.selectFilterClass}>
            <StyledSelect
              id={id}
              label={label}
              textFieldProps={{
                id,
                label: placeHolder,
                variant: 'outlined'
              }}
              value={value}
              InputLabelProps={{
                classes: {
                  root: classes.InputLabelProps
                }
              }}
              menuPosition="fixed"
              error={Boolean(error)}
              inputClass={classes.selectInput}
              {...otherProps}
            />
          </div>
          <div className={classes.errorText}>{error || ''}</div>
        </div>
        {suffix && <span className={classes.suffix}>{suffix}</span>}
      </div>
    </div>
  );
};

export default withStyles(styles)(PromptConfirmationSelectWithLabel);
